import React, { useEffect, useState } from 'react';
import './HomeHero.css';

export default function HomeHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <header className={`home-hero ${loaded ? 'loaded' : ''}`}>
      <div className="home-hero__badges">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.9375rem' }}>
          <img
            src="https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68b00b267e0fc974f64d6d3c_RENART_GLOBAL_TR_English_2025_Certification_Badge.png"
            alt="Great Place to Work"
            className="badge-img"
          />
          <img
            src="https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68b00c3b460925664fdcbba4_ENG%202025_TU%CC%88RKI%CC%87YE_Perakende_national.png"
            alt="Best Workplaces"
            className="badge-img"
          />
        </div>
      </div>
      <div className="home-hero__center">
        <h1 className="home-hero__title">renart</h1>
      </div>

      <div className="build-brands__topbar">
        <span className="build-brands__topbar-left">Since 1971</span>
        <span className="build-brands__topbar-center">Rethink Retail</span>
        <div className="build-brands__topbar-right">
          <span>Scroll Down</span>
          <div className="build-brands__scroll-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.0001 16.1716L18.3641 10.8076L19.7783 12.2218L12.0001 20L4.22192 12.2218L5.63614 10.8076L11.0001 16.1716V4H13.0001V16.1716Z"/>
            </svg>
          </div>
        </div>
      </div>
    </header>
  );
}